const __WEBPACK_NAMESPACE_OBJECT__ = require("live/components/forms/ui/slider-with-input");